import { motion } from "framer-motion";

export const ease = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 30, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease, delay }}
    >
      {children}
    </motion.div>
  );
}

export function SectionLabel({ index, children }) {
  return (
    <div className="flex items-center gap-4">
      <span className="eyebrow">{index}</span>
      <span className="h-px w-12 bg-[#D4A359]/60" />
      <span className="eyebrow !text-[var(--stone)]">{children}</span>
    </div>
  );
}
